import { useEffect, useState } from 'react';


import request from '../helpers/requests';
import { getData, saveData, saveImage, saveImagePath, getImage } from '../helpers/indexedDbHelper';
import { constants, isLocalMirror } from '../config/constants';

export const useRefresh = () => {

  const [change, setChange] = useState(0);
  const downloadImage = async (url, id, changeimage) => {
    // Espejo local: el binario ya está en disco, solo se registra la ruta.
    if (isLocalMirror) {
      await saveImagePath(id, url, changeimage);
      return;
    }

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      await saveImage(id, {blob, changeimage});
    } catch (error) {
      console.error(`Error al descargar la imagen ${id}:`, error);
    }
  };

  const getInitData = async () => {
    // En el espejo local este hook NO hace nada.
    //
    // Era una segunda vía de actualización corriendo en paralelo a useInit:
    // dos mecanismos escribiendo el mismo IndexedDB, cada uno con su propio
    // criterio de "cambió", pisándose según cuál llegara antes. De ahí que a
    // veces refrescara y a veces no. Quien actualiza es la app nativa, y
    // useInit lee el resultado antes de pintar.
    if (isLocalMirror) return;

    console.log('veryfing');

      const validImages = async (id) => {
      const data = await getImage(id);
      return data;
    };



    const dataDb = await getData('menu');

    const hash = '71277721124d0005k4z390b0apphabaneros.com2121';
    const { data } = await request.get(`/all/menu/web/${hash}`);

    // Sin menu guardado todavia no hay con que comparar: se guarda y listo.
    // Antes esto reventaba en dataDb.value y mataba el refresco periodico.
    if (!dataDb?.value) {
      await saveData('menu', data);
      return;
    }


    // En el espejo local NO se recarga desde aquí: quien manda es la app
    // nativa, que sincroniza y recarga una sola vez. Si además recargara el
    // appweb, el cliente veria un segundo refresco unos segundos despues.
    if (!isLocalMirror && data.refresh_app != dataDb.value.refresh_app) {
      console.log("refresh")
      window.location.reload();
    }

    if (data.change_menu != dataDb.value.change_menu) {
      console.log('updateing menu');
      await saveData('menu', data);

      // Crear una lista de promesas para todas las imágenes
        const downloadPromises = [];

        data.data.forEach((item) => {
          const images = [
            ...item.menus.map((menu) => ({
              url: menu.image,
              changeimage: menu.changeimage,
              id: `menu-image-${menu.id}`,
            })),
            ...item.menus.map((menu) => ({
              url: menu.imagehorizontal,
              changeimage: menu.changeimagehorizontal,
              id: `menu-image-h-${menu.id}`,
            })),
          ];

          images.forEach(({ url, id, changeimage }) => {
            if (url) {
              const fullUrl = `${constants.pathImagesMenu}/${url}`;
              downloadPromises.push(
                (async () => {
                  const validImage = await validImages(id);
                  if (validImage.data.changeimage != changeimage) {
                    console.log('Downloading image', fullUrl, id);
                    await downloadImage(fullUrl, id, changeimage);
                  }
                })()
              );
            }
          });
        });
      // Esperar a que todas las imágenes se descarguen
      await Promise.all(downloadPromises);
      setChange(Math.random(1,9999));
    }
  };

  useEffect(() => {
    // En el espejo local NO se consulta nada periodicamente.
    //
    // Este hook esta instanciado en una veintena de pantallas, asi que creaba
    // ~20 temporizadores disparando a la vez cada 5 minutos. Ademas aqui no
    // hace falta: la app nativa sincroniza y recarga cuando hay algo nuevo.
    if (isLocalMirror) return undefined;

    const tick = () => {
      getInitData().catch((e) => console.warn('[Kiosko] Refresco fallido:', e));
    };
    const id = setInterval(tick, 300000);
    return () => clearInterval(id);
  }, []);


  return { change, getInitData };


};
